import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    $(document).ready(function() {
      if ($('.medias').length > 0) {
        $('.medias').scrollTop($('.medias')[0].scrollHeight);
      }
    });
  }
}
